import { signInCreateNewAccountStyles } from "@insite/content-library/Widgets/SignIn/SignInCreateNewAccount"
import { BaseTheme } from "@insite/mobius/globals/baseTheme"
import { breakpointMediaQueries } from "@insite/mobius/utilities"
import { css } from "styled-components"

signInCreateNewAccountStyles.signInCreateNewAccountTitle = {
    variant: "h4",
    css:css`
        margin-bottom:0px;
    `,
}

signInCreateNewAccountStyles.signInCreateNewAccountButtonGridItem = {
    width: 12,
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        flex-direction: row;
                    `,
                    css`
                        flex-direction: row;
                    `,
                    css`
                        flex-direction: row;
                    `,
                    css`
                        flex-direction: column;
                        // justify-content: space-between;
                    `,
                    css`
                        flex-direction: row;
                        justify-content: flex-start;
                    `,
                ]
            )}
    `,
}

signInCreateNewAccountStyles.checkoutAsGuestButton = {
    mergeCss:true,
    variant: "primary",
    css: css`
        padding:0px 18px;
        span {
            color: #ffffff;
        }
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        margin-right:20px;
                        padding:0px 5px;
                    `,
                    css`
                        margin-right:20px;
                    `,
                    css`
                        margin-right:20px;
                    `,
                    css`
                        margin-bottom: 1rem;
                    `,
                    css`
                        margin-bottom: 1rem;
                        margin-right:10px;
                        padding:0px 10px;
                    `,
                ]
            )}
    `,
}